<template>
  <div class="px-1 pb-1">

    <!-- ÜST BÖLÜM: Maaş Destek Ücreti (Banka 2 / Yemek) - Ayrı tablo, ay-yıl bazlı -->
    <div class="alert mb-1 border">
      <div class="alert-body p-1">
        <div class="row">
          <div class="col-12 mb-1">
            <label class="form-label font-weight-bolder">Maaş Destek Ücreti</label>
          </div>
          <div class="col-md-3 mb-1">
            <label class="form-label">Geçerlilik Ayı</label>
            <select
              v-model.number="support.EffectiveMonth"
              class="form-control"
            >
              <option
                v-for="m in months"
                :key="'sm'+m.value"
                :value="m.value"
              >
                {{ m.text }}
              </option>
            </select>
          </div>
          <div class="col-md-3 mb-1">
            <label class="form-label">Geçerlilik Yılı</label>
            <select
              v-model.number="support.EffectiveYear"
              class="form-control"
            >
              <option
                v-for="y in years"
                :key="'sy'+y"
                :value="y"
              >
                {{ y }}
              </option>
            </select>
          </div>
          <div class="col-md-3 mb-1">
            <label class="form-label">Maaş Destek Ücreti [Banka 2]</label>
            <v-currency-input
              input-class="text-right"
              :value="support.SupportBanka2"
              @update-value="v => support.SupportBanka2 = v"
            />
          </div>
          <div class="col-md-3 mb-1">
            <label class="form-label">Maaş Destek Ücreti [Yemek]</label>
            <v-currency-input
              input-class="text-right"
              :value="support.SupportYemek"
              @update-value="v => support.SupportYemek = v"
            />
          </div>
          <div class="col-12 text-right">
            <v-executer
              :loading="savingSupport"
              :disabled="!supportHasValue"
              text="Maaş Destek Ücretini Kaydet"
              :action="saveSupport"
            />
          </div>

          <!-- Maaş Destek kayıtları (aktif + geçmiş) -->
          <div class="col-12 mt-1">
            <label class="form-label">Kayıtlar</label>
            <div
              v-if="!supportList.length"
              class="text-muted small mb-0"
            >
              Henüz kayıt yok.
            </div>
            <template v-else>
              <table class="table table-sm table-bordered mb-0">
                <thead>
                  <tr>
                    <th>Geçerlilik</th>
                    <th class="text-right">
                      Banka 2
                    </th>
                    <th class="text-right">
                      Yemek
                    </th>
                    <th class="text-center">
                      Durum
                    </th>
                    <th class="text-right" />
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="row in supportList"
                    :key="row.Id"
                    :class="{ 'text-muted bg-light': row.IsHistory }"
                  >
                    <td>{{ monthText(row.EffectiveMonth) }} {{ row.EffectiveYear }}</td>
                    <td class="text-right">
                      {{ formatMoney(row.SupportBanka2) }}
                    </td>
                    <td class="text-right">
                      {{ formatMoney(row.SupportYemek) }}
                    </td>
                    <td class="text-center">
                      <b-badge :variant="row.IsHistory ? 'light-secondary' : 'light-success'">
                        {{ row.IsHistory ? 'Geçmiş' : 'Aktif' }}
                      </b-badge>
                    </td>
                    <td class="text-right">
                      <b-button
                        v-if="!row.IsHistory"
                        size="sm"
                        variant="flat-danger"
                        @click="deleteSupport(row.Id)"
                      >
                        Sil
                      </b-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </template>
          </div>
        </div>
      </div>
    </div>

    <!-- ALT BÖLÜM: Ek Hakedişler (Yemek / Yol) - EmployeeAllowance tablosu, ay-yıl bazlı -->
    <div class="alert mb-0 border">
      <div class="alert-body p-1">
        <div class="row">
          <div class="col-12 mb-1">
            <label class="form-label font-weight-bolder">Ek Hakedişler (Yemek / Yol)</label>
          </div>

          <div class="col-md-3 mb-1">
            <label class="form-label">Geçerlilik Ayı</label>
            <select
              v-model.number="allowance.EffectiveMonth"
              class="form-control"
            >
              <option
                v-for="m in months"
                :key="'am'+m.value"
                :value="m.value"
              >
                {{ m.text }}
              </option>
            </select>
          </div>
          <div class="col-md-3 mb-1">
            <label class="form-label">Geçerlilik Yılı</label>
            <select
              v-model.number="allowance.EffectiveYear"
              class="form-control"
            >
              <option
                v-for="y in years"
                :key="'ay'+y"
                :value="y"
              >
                {{ y }}
              </option>
            </select>
          </div>
          <div class="col-12" />

          <!-- YEMEK -->
          <div class="col-12 mt-1">
            <b-form-checkbox
              v-model="allowance.Yemek"
              class="ml-50"
              @change="onYemekChange"
            >
              Yemek
            </b-form-checkbox>
          </div>
          <div
            v-if="allowance.Yemek"
            class="col-12 ml-50 mt-50"
          >
            <div
              v-if="currentYemek1 == null"
              class="alert alert-warning py-50 px-1 mb-1"
            >
              <small>İK Parametrelerinde <b>Yemek 1</b> değeri tanımlı değil; kayıt <b>boş</b> Yemek 1 ile yapılacak. Lütfen İnsan Kaynakları Sabitleri ekranından tanımlayın.</small>
            </div>
            <div class="row">
              <div class="col-md-4 mb-1">
                <label class="form-label">Yemek 1 (İK Parametresi - güncel)</label>
                <v-currency-input
                  input-class="text-right"
                  :value="currentYemek1"
                  :disabled="true"
                />
              </div>
              <div class="col-md-4 mb-1">
                <label class="form-label">Yemek 2</label>
                <v-currency-input
                  input-class="text-right"
                  :value="allowance.Yemek2"
                  @update-value="v => allowance.Yemek2 = v"
                />
              </div>
              <div class="col-md-4 mb-1">
                <label class="form-label">Katsayı (0-31)</label>
                <v-currency-input
                  input-class="text-right"
                  :fraction-digits="2"
                  :value="allowance.YemekGun"
                  @update-value="v => allowance.YemekGun = clampDay(v)"
                />
              </div>
            </div>
          </div>

          <!-- YOL -->
          <div class="col-12 mt-1">
            <b-form-checkbox
              v-model="allowance.Yol"
              class="ml-50"
              @change="onYolChange"
            >
              Yol
            </b-form-checkbox>
          </div>
          <div
            v-if="allowance.Yol"
            class="col-12 ml-50 mt-50"
          >
            <div
              v-if="currentYol1 == null"
              class="alert alert-warning py-50 px-1 mb-1"
            >
              <small>İK Parametrelerinde <b>Yol 1</b> değeri tanımlı değil; kayıt <b>boş</b> Yol 1 ile yapılacak. Lütfen İnsan Kaynakları Sabitleri ekranından tanımlayın.</small>
            </div>
            <div class="row">
              <div class="col-md-4 mb-1">
                <label class="form-label">Yol 1 (İK Parametresi - güncel)</label>
                <v-currency-input
                  input-class="text-right"
                  :value="currentYol1"
                  :disabled="true"
                />
              </div>
              <div class="col-md-4 mb-1">
                <label class="form-label">Yol 2</label>
                <v-currency-input
                  input-class="text-right"
                  :value="allowance.Yol2"
                  @update-value="v => allowance.Yol2 = v"
                />
              </div>
              <div class="col-md-4 mb-1">
                <label class="form-label">Katsayı (0-31)</label>
                <v-currency-input
                  input-class="text-right"
                  :fraction-digits="2"
                  :value="allowance.YolGun"
                  @update-value="v => allowance.YolGun = clampDay(v)"
                />
              </div>
            </div>
          </div>

          <div class="col-12 text-right mt-1">
            <v-executer
              :loading="savingAllowance"
              :disabled="!allowanceValid"
              text="Ek Hakediş Bilgilerini Kaydet"
              :action="saveAllowance"
            />
          </div>

          <!-- Ek Hakediş kayıtları (aktif + geçmiş) -->
          <div class="col-12 mt-1">
            <label class="form-label">Kayıtlar</label>
            <div
              v-if="!allowanceList.length"
              class="text-muted small mb-0"
            >
              Henüz kayıt yok.
            </div>
            <table
              v-else
              class="table table-sm table-bordered mb-0"
            >
              <thead>
                <tr>
                  <th>Geçerlilik</th>
                  <th class="text-center">
                    Yemek
                  </th>
                  <th class="text-right">
                    Yemek 1
                  </th>
                  <th class="text-right">
                    Yemek 2
                  </th>
                  <th class="text-right">
                    Y. Gün
                  </th>
                  <th class="text-center">
                    Yol
                  </th>
                  <th class="text-right">
                    Yol 1
                  </th>
                  <th class="text-right">
                    Yol 2
                  </th>
                  <th class="text-right">
                    Y. Gün
                  </th>
                  <th class="text-center">
                    Durum
                  </th>
                  <th />
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="row in allowanceList"
                  :key="row.Id"
                  :class="{ 'text-muted bg-light': row.IsHistory }"
                >
                  <td>{{ monthText(row.EffectiveMonth) }} {{ row.EffectiveYear }}</td>
                  <td class="text-center">
                    {{ row.Yemek ? '✓' : '' }}
                  </td>
                  <td class="text-right">
                    {{ formatMoney(row.Yemek1) }}
                  </td>
                  <td class="text-right">
                    {{ formatMoney(row.Yemek2) }}
                  </td>
                  <td class="text-right">
                    {{ formatDay(row.YemekGun) }}
                  </td>
                  <td class="text-center">
                    {{ row.Yol ? '✓' : '' }}
                  </td>
                  <td class="text-right">
                    {{ formatMoney(row.Yol1) }}
                  </td>
                  <td class="text-right">
                    {{ formatMoney(row.Yol2) }}
                  </td>
                  <td class="text-right">
                    {{ formatDay(row.YolGun) }}
                  </td>
                  <td class="text-center">
                    <b-badge :variant="row.IsHistory ? 'light-secondary' : 'light-success'">
                      {{ row.IsHistory ? 'Geçmiş' : 'Aktif' }}
                    </b-badge>
                  </td>
                  <td class="text-right">
                    <b-button
                      v-if="!row.IsHistory"
                      size="sm"
                      variant="flat-danger"
                      @click="deleteAllowance(row.Id)"
                    >
                      Sil
                    </b-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations'
import { BFormCheckbox, BButton, BBadge } from 'bootstrap-vue'
import VCurrencyInput from '@/components/VCurrencyInput.vue'

export default {
  components: {
    BFormCheckbox,
    BButton,
    BBadge,
    VCurrencyInput,
  },
  props: {
    id: [String, Number],
  },
  data() {
    const now = new Date()
    const currentYear = now.getFullYear()
    const currentMonth = now.getMonth() + 1
    return {
      months: [
        { value: 1, text: 'Ocak' }, { value: 2, text: 'Şubat' }, { value: 3, text: 'Mart' },
        { value: 4, text: 'Nisan' }, { value: 5, text: 'Mayıs' }, { value: 6, text: 'Haziran' },
        { value: 7, text: 'Temmuz' }, { value: 8, text: 'Ağustos' }, { value: 9, text: 'Eylül' },
        { value: 10, text: 'Ekim' }, { value: 11, text: 'Kasım' }, { value: 12, text: 'Aralık' },
      ],
      years: Array.from({ length: 11 }, (_, i) => currentYear - 5 + i),
      currentYemek1: null,
      currentYol1: null,
      allowance: {
        EffectiveYear: currentYear,
        EffectiveMonth: currentMonth,
        Yemek: false,
        Yemek2: null,
        YemekGun: null,
        Yol: false,
        Yol2: null,
        YolGun: null,
      },
      allowanceList: [],
      support: {
        EffectiveYear: currentYear,
        EffectiveMonth: currentMonth,
        SupportBanka2: null,
        SupportYemek: null,
      },
      supportList: [],
      savingAllowance: false,
      savingSupport: false,
    }
  },
  computed: {
    supportHasValue() {
      return this.support.SupportBanka2 != null || this.support.SupportYemek != null
    },
    // Ek Hakediş kaydedilebilir mi: en az bir tür seçili VE seçili türlerin günü 0-31 aralığında geçerli olmalı.
    allowanceValid() {
      if (!this.allowance.Yemek && !this.allowance.Yol) return false
      if (this.allowance.Yemek && !this.isValidDay(this.allowance.YemekGun)) return false
      if (this.allowance.Yol && !this.isValidDay(this.allowance.YolGun)) return false
      return true
    },
  },
  watch: {
    id() {
      this.resetAllowanceForm()
      this.resetSupportForm()
      this.loadAllowances()
      this.loadSupports()
    },
  },
  mounted() {
    this.loadAllowances()
    this.loadSupports()
  },
  methods: {
    monthText(m) {
      const f = this.months.find(x => x.value === m)
      return f ? f.text : m
    },
    formatMoney(v) {
      if (v == null || Number.isNaN(Number(v))) return '-'
      return new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(v)
    },
    formatDay(v) {
      if (v == null || Number.isNaN(Number(v))) return '-'
      return new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(v)
    },
    // Gün alanı için 0-31 sınırı: 31'den büyük değer girilirse otomatik 31'e çekilir, negatif 0'a.
    clampDay(v) {
      if (v == null || Number.isNaN(Number(v))) return null
      let n = Number(v)
      if (n > 31) n = 31
      if (n < 0) n = 0
      return n
    },
    isValidDay(v) {
      return v != null && !Number.isNaN(Number(v)) && Number(v) > 0 && Number(v) <= 31
    },
    resetAllowanceForm() {
      const now = new Date()
      this.allowance = {
        EffectiveYear: now.getFullYear(),
        EffectiveMonth: now.getMonth() + 1,
        Yemek: false,
        Yemek2: null,
        YemekGun: null,
        Yol: false,
        Yol2: null,
        YolGun: null,
      }
    },
    resetSupportForm() {
      const now = new Date()
      this.support = {
        EffectiveYear: now.getFullYear(),
        EffectiveMonth: now.getMonth() + 1,
        SupportBanka2: null,
        SupportYemek: null,
      }
    },
    onYemekChange(checked) {
      if (checked) { if (this.allowance.YemekGun == null) this.allowance.YemekGun = 30 } else { this.allowance.Yemek2 = null; this.allowance.YemekGun = null }
    },
    onYolChange(checked) {
      if (checked) { if (this.allowance.YolGun == null) this.allowance.YolGun = 30 } else { this.allowance.Yol2 = null; this.allowance.YolGun = null }
    },
    loadAllowances() {
      EmployeeOperationsApi.Employee.GetAllowances(this.id).then(res => {
        if (res.data.Success) {
          this.currentYemek1 = res.data.Data.CurrentYemek1
          this.currentYol1 = res.data.Data.CurrentYol1
          this.allowanceList = res.data.Data.Items || []
        } else {
          this.$result(res)
        }
      }).catch(err => this.$result(null, err))
    },
    loadSupports() {
      EmployeeOperationsApi.Employee.GetSalarySupports(this.id).then(res => {
        if (res.data.Success) {
          this.supportList = res.data.Data || []
        } else {
          this.$result(res)
        }
      }).catch(err => this.$result(null, err))
    },
    saveAllowance(overwrite = false) {
      this.savingAllowance = true
      EmployeeOperationsApi.Employee.SaveAllowance({
        EmployeeId: this.id,
        EffectiveYear: this.allowance.EffectiveYear,
        EffectiveMonth: this.allowance.EffectiveMonth,
        Yemek: this.allowance.Yemek,
        Yemek2: this.allowance.Yemek2,
        YemekGun: this.allowance.YemekGun,
        Yol: this.allowance.Yol,
        Yol2: this.allowance.Yol2,
        YolGun: this.allowance.YolGun,
        Overwrite: overwrite,
      }).then(res => {
        // Aynı dönem için kayıt varsa backend onay ister (RequiresConfirmation).
        // Onay penceresi açıkken loading true kalır ki çift kayıt tetiklenmesin.
        if (res.data.Success && res.data.Data && res.data.Data.RequiresConfirmation) {
          this.$confirm('Onay', res.data.Data.ConfirmationMessage).then(ok => {
            if (ok) { this.saveAllowance(true) } else { this.savingAllowance = false }
          }).catch(() => { this.savingAllowance = false })
          return
        }
        this.savingAllowance = false
        this.$result(res)
        if (res.data.Success) {
          this.resetAllowanceForm()
          this.loadAllowances()
        }
      }).catch(err => {
        this.savingAllowance = false
        this.$result(null, err)
      })
    },
    deleteAllowance(id) {
      this.$confirm('Onay', 'Bu dönemin ek hakediş kaydını silmek istediğinize emin misiniz? Silinirse bu dönem boş kalır; önceki geçmiş versiyon otomatik geri gelmez.').then(ok => {
        if (!ok) return
        EmployeeOperationsApi.Employee.DeleteAllowance(id).then(res => {
          this.$result(res)
          if (res.data.Success) this.loadAllowances()
        }).catch(err => this.$result(null, err))
      })
    },
    saveSupport(overwrite = false) {
      this.savingSupport = true
      EmployeeOperationsApi.Employee.SaveSalarySupport({
        EmployeeId: this.id,
        EffectiveYear: this.support.EffectiveYear,
        EffectiveMonth: this.support.EffectiveMonth,
        SupportBanka2: this.support.SupportBanka2,
        SupportYemek: this.support.SupportYemek,
        Overwrite: overwrite,
      }).then(res => {
        if (res.data.Success && res.data.Data && res.data.Data.RequiresConfirmation) {
          this.$confirm('Onay', res.data.Data.ConfirmationMessage).then(ok => {
            if (ok) { this.saveSupport(true) } else { this.savingSupport = false }
          }).catch(() => { this.savingSupport = false })
          return
        }
        this.savingSupport = false
        this.$result(res)
        if (res.data.Success) {
          this.resetSupportForm()
          this.loadSupports()
        }
      }).catch(err => {
        this.savingSupport = false
        this.$result(null, err)
      })
    },
    deleteSupport(id) {
      this.$confirm('Onay', 'Bu dönemin maaş destek kaydını silmek istediğinize emin misiniz? Silinirse bu dönem boş kalır; önceki geçmiş versiyon otomatik geri gelmez.').then(ok => {
        if (!ok) return
        EmployeeOperationsApi.Employee.DeleteSalarySupport(id).then(res => {
          this.$result(res)
          if (res.data.Success) this.loadSupports()
        }).catch(err => this.$result(null, err))
      })
    },
  },
}
</script>

<style></style>
